// Per-screen translation namespaces. Each part file exports one object keyed
// by language code; `mergeParts` folds them into the i18n resource bundles.
export type LangMap = Record<string, Record<string, unknown>>;

export function mergeParts(
  base: Record<string, Record<string, unknown>>,
  parts: Record<string, LangMap>,
): Record<string, Record<string, unknown>> {
  const out: Record<string, Record<string, unknown>> = {};
  for (const lang of Object.keys(base)) {
    out[lang] = { ...base[lang] };
    for (const [ns, byLang] of Object.entries(parts)) {
      const value = byLang[lang] ?? byLang.en;
      if (value) out[lang][ns] = value;
    }
  }
  return out;
}
